import PropTypes from 'prop-types';

export const PremiumInstallmentPropTypes = PropTypes.shape({
  Amount: PropTypes.number,
  AnimalDateOfBirth: PropTypes.string,
  AnimalName: PropTypes.string,
  CustomerId: PropTypes.string,
  DueAmount: PropTypes.number,
  FullPolicyNumber: PropTypes.string,
  InstalmentLineNumber: PropTypes.number,
  InstalmentNumber: PropTypes.number,
  LastRejectedDate: PropTypes.string,
  NextCollectionDate: PropTypes.string,
  NumberOfRejections: PropTypes.number,
  OriginalDueDate: PropTypes.string,
  PartnerNumber: PropTypes.string,
  PolicyNumber: PropTypes.string,
  Status: PropTypes.string,
  isSelected: PropTypes.bool,
  isValid: PropTypes.bool
});

export const OutstandingPaymentPropTypes = PropTypes.shape({
  PetName: PropTypes.string,
  PolicyNumber: PropTypes.string,
  FullPolicyNumber: PropTypes.string,
  PetDOB: PropTypes.string,
  PremiumInstallment: PropTypes.arrayOf(PremiumInstallmentPropTypes)
});
